import React, { createContext, useContext, useState, useEffect } from "react";
import { extra } from "./i18n_extra";
import { extraFr } from "./i18n_extra_fr";
import { extraDe } from "./i18n_extra_de";
import { extraEs } from "./i18n_extra_es";
import { batch2 } from "./i18n_batch2";

extra.fr = extraFr;
extra.de = extraDe;
extra.es = extraEs;
for (const l of Object.keys(batch2)) extra[l] = mergeDeep(extra[l] || {}, batch2[l]);

export const translations = {
  it: {
    nav: {
      about: "Chi Siamo",
      concept: "Richiedi Concept",
      pricing: "Piani",
      consulting: "Consulenza Diretta",
      contact: "Contatti",
      method: "Metodo",
      contactSupport: "Contatti e supporto",
      cta: "Lighting Concept",
    },
    hero: {
      overline: "Progettazione illuminotecnica d'autore",
      title: "La luce non si accende. Si disegna.",
      subtitle: "FArLight è la piattaforma di lighting design che trasforma la luce nell'identità degli spazi. Nasce dall'idea di due professioniste, l'Arch. e Lighting Designer Alessia Follari e l'Arch. Alessandra Floridia, con l'obiettivo di rendere la progettazione della luce semplice, personale e d'autore.",
      ctaPrimary: "Lighting Concept",
      ctaSecondary: "Consulenza Esecutiva",
      ctaCallNote: "15 minuti, gratuita",
      videoCaption: "Guarda il video di presentazione",
      videoSoon: "Il video di presentazione di Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia sarà disponibile a breve",
      founders: "Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia — Fondatrici",
    },
    manifesto: {
      overline: "Manifesto — Chi Siamo",
      title: "Due professioniste nel campo del lighting e dell'architettura, una sola visione della luce.",
      p1: "FARlight nasce a Palermo dall'incontro tra Arch. e Lighting Designer Alessia Follari e Architetto Alessandra Floridia, colleghe di università ai tempi degli studi di architettura. Oggi uniscono ingegneria illuminotecnica e design italiano in una firma che cura personalmente ogni progetto di luce.",
      p2: "Ogni elaborato nasce dal lavoro diretto delle Architette, con precisione fotometrica, concept illuminotecnico su misura e verifica normativa UNI EN 12464-1 e la firma di chi progetta la luce da oltre dieci anni.",
      p3: "Ci invii la pianta e noi creiamo per te un Lighting Concept pronto a guidare ogni tua scelta.",
      signature: "Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia",
      signatureRole: "Fondatrici di FArLight",
    },
    strengths: {
      overline: "L'essenza creativa e sostenibile della luce",
      title: "L'essenza creativa e sostenibile della luce.",
      items: [
        { title: "La Luce come Funzione ed Emozione", desc: "La luce guida i comportamenti, valorizza i volumi e riduce l'affaticamento visivo. Negli uffici, nel retail e in casa progettiamo scenari che lavorano per le persone." },
        { title: "Sostenibilità e Risparmio Energetico Intelligente", desc: "Calcolo rigoroso del LENI (Lighting Energy Numerical Indicator) e flussi luminosi mirati, per meno watt dispersi, minore impatto ambientale, comfort invariato." },
        { title: "Lighting Design d'Eccellenza, per Tutti", desc: "Concept illuminotecnici completi, scientifici e rapidi, la qualità di una progettazione d'autore accessibile a ogni progetto, con la cura di uno studio." },
        { title: "Garantire Risultati Reali & Verificabili", desc: "Corrispondenza puntuale su file .LDT, report illuminotecnici con normative UNI di riferimento (UNI EN 12464-1 interni, UNI EN 12464-2 esterni, UNI EN 13201-2/3/4 stradale, UNI 10819 inquinamento luminoso) e disegni esecutivi, così ogni scelta è verificabile, ordinabile e pronta per il cantiere." },
      ],
    },
    tutorial: {
      overline: "Video Tutorial",
      title: "Come funziona la piattaforma, passo dopo passo.",
      subtitle: "In pochi minuti scopri come caricare le piante, compilare la richiesta e ricevere il tuo concept illuminotecnico.",
      steps: [
        { title: "Prepara i file", desc: "Raccogli piante e layout dello spazio in formato PDF, JPG o PNG." },
        { title: "Compila il modulo", desc: "Indica tipologia, superficie, altezza, budget e stile, bastano due minuti." },
        { title: "Invia e rilassati", desc: "Verifichiamo i dati e avviamo subito la lavorazione del concept." },
        { title: "Ricevi il report", desc: "Report PDF, moodboard e lista budget arrivano direttamente via email." },
      ],
      videoCaption: "Guarda il video tutorial",
      videoSoon: "Il video tutorial sarà disponibile a breve",
    },
    form: {
      overline: "Richiedi Concept Preliminare",
      title: "Carica le tue piante, al resto pensiamo noi.",
      leftTitle: "Come funziona",
      steps: [
        "Compila il modulo con le caratteristiche dello spazio",
        "Allega piante e layout (PDF, JPG, PNG)",
        "Ricevi il report preliminare firmato FArLight",
      ],
      disclaimerShort: "Consulenza preliminare di concept e fattibilità illuminotecnica.",
      name: "Nome e Cognome / Studio",
      namePlaceholder: "Es. Studio Bianchi oppure Mario Rossi",
      email: "Email",
      emailPlaceholder: "nome@esempio.it",
      spaceType: "Tipologia di spazio",
      spaceTypePlaceholder: "Seleziona la tipologia",
      spaceTypes: {
        residenziale: "Residenziale",
        retail: "Retail / Negozio",
        uffici: "Uffici",
        outdoor: "Outdoor",
        ristorazione: "Ristorazione",
      },
      surface: "Superficie (mq)",
      surfacePlaceholder: "Es. 85",
      ceiling: "Altezza soffitto (m)",
      ceilingPlaceholder: "Es. 2.7",
      budget: "Fascia di budget desiderata",
      budgetPlaceholder: "Seleziona la fascia",
      budgets: {
        economico: "Economico",
        medio: "Medio",
        alto: "Alto",
      },
      style: "Stile di illuminazione preferito",
      stylePlaceholder: "Es. caldo e minimale, scenografico, tecnico...",
      surfaceApprox: "Indicativa / non ho la certezza", surfaceApproxShort: "indicativa",
      upload: "Allega piante e layout",
      uploadHint: "PDF, JPG o PNG — max 20MB per file",
      uploadButton: "Scegli file",
      uploadEmpty: "Nessun file selezionato",
      lampSchedule: "Aggiungi l'Abaco Lampade per i rivenditori",
      lampScheduleHint: "Elenco con marche, modelli, foto e codici di riferimento da girare direttamente a distributori e rivenditori di zona, che prepareranno il capitolato ufficiale con prezzi e sconti decisi in autonomia.",
      preferredBrands: "Brand selezionati dai cataloghi",
      notes: "Note e vincoli di cantiere",
      notesPlaceholder: "Es. travi a vista, punti luce esistenti, vincoli condominiali...",
      submit: "Invia richiesta",
      submitting: "Invio in corso...",
      successTitle: "Richiesta inviata",
      successDesc: "Grazie! Ti abbiamo inviato un'email di conferma ed entro pochi minuti riceverai una seconda email con il link al report PDF. Puoi seguire l'avanzamento anche nell'area personale (accedi con la stessa email).",
      errorDesc: "Qualcosa è andato storto. Riprova o scrivici a info.farlight.official@gmail.com",
    },
    catalogs: {
      overline: "Risorse per progettisti",
      title: "Cataloghi e schede tecniche dei migliori brand.",
      subtitle: "I link ai siti ufficiali dei produttori per consultare cataloghi scaricabili e schede tecniche per selezionare le lampade da inserire nei tuoi progetti.",
      note: "Cataloghi e schede tecniche sono ospitati sui siti ufficiali dei rispettivi produttori.",
      visit: "Visita il sito",
      selectHint: "Tocca una card per selezionare i brand preferiti — la freccia apre il sito ufficiale",
      addToRequest: "Aggiungi alla richiesta",
    },
    pricing: {
      overline: "Piani e listino",
      title: "Prezzi chiari, senza sorprese.",
      subtitle: "Scegli la prestazione singola o l'abbonamento pensato per studi e showroom.",
      disclaimer: "Tutti i report costituiscono una Consulenza Preliminare di Concept e Fattibilità Illuminotecnica per guidare le scelte iniziali e stimare i costi.",
      loading: "Reindirizzamento al pagamento sicuro...",
      error: "Impossibile avviare il pagamento. Riprova tra poco.",
      secure: "Pagamento sicuro con Stripe",
    },
    escalation: {
      overline: "Consulenza Diretta Studio",
      title: "Progetti complessi? Parliamone di persona.",
      subtitle: "Hotel, restauro, opere pubbliche e retail avanzato richiedono un approccio su misura. Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia prendono in carico personalmente il tuo progetto, dal sopralluogo alla firma.",
      tags: ["Hotel", "Restauri", "Opere Pubbliche", "Retail avanzato"],
      cta: "Richiedi la presa in carico",
    },
    contact: {
      overline: "Contatti & Supporto",
      title: "Scrivici, rispondiamo in fretta.",
      name: "Nome",
      namePlaceholder: "Il tuo nome",
      email: "Email",
      emailPlaceholder: "nome@esempio.it",
      topic: "Tipo di richiesta",
      topicSupport: "Supporto clienti",
      topicDirect: "Consulenza Diretta Studio",
      message: "Messaggio",
      messagePlaceholder: "Raccontaci il tuo progetto o la tua domanda...",
      submit: "Invia messaggio",
      submitting: "Invio in corso...",
      successTitle: "Messaggio inviato",
      successDesc: "Grazie! Ti risponderemo al più presto.",
      errorDesc: "Invio non riuscito. Scrivici direttamente a info.farlight.official@gmail.com",
      emailLabel: "Email supporto",
    },
    footer: {
      tagline: "Progettazione illuminotecnica d'autore.",
      rights: "Tutti i diritti riservati.",
    },
    payment: {
      cardLabel: "Carta di credito / debito", cardDesc: "Pagamento sicuro con Stripe (Visa, Mastercard, Amex, Apple/Google Pay).", paypalDesc: "Paga con il tuo saldo o conto PayPal.", paypalSoon: "Disponibile a breve.",
      successTitle: "Carta autorizzata, nessun addebito",
      successDesc: "Grazie per aver scelto FArLight. Il pagamento è stato confermato. La tua richiesta è già in lavorazione, riceverai un'email di conferma e potrai seguire l'avanzamento nell'Area Riservata.",
      pendingTitle: "Verifica del pagamento in corso...",
      pendingDesc: "Stiamo confermando l'autorizzazione con Stripe.",
      failedTitle: "Pagamento non confermato",
      failedDesc: "Non siamo riusciti a confermare il pagamento. Se l'addebito è avvenuto, scrivici a info.farlight.official@gmail.com",
      backHome: "Torna alla home",
      cancelTitle: "Pagamento annullato",
      cancelDesc: "Nessun addebito è stato effettuato. Puoi riprendere quando vuoi dalla sezione Piani.",
      retry: "Vedi i piani",
    },
    auth: {
      login: "Accedi",
      register: "Registrati",
      logout: "Esci",
      name: "Nome",
      email: "Email",
      password: "Password",
      google: "Continua con Google",
      noAccount: "Non hai un account?",
      haveAccount: "Hai già un account?",
      loginTitle: "Accedi a FArLight",
      registerTitle: "Crea il tuo account",
      subtitle: "Le tue richieste e lo stato di lavorazione",
      orDivider: "oppure",
      loginError: "Credenziali non valide",
      registerError: "Registrazione non riuscita (email già in uso?)",
      forgot: "Password dimenticata?", forgotTitle: "Reimposta la password", forgotText: "Inserisci l'email del tuo account: ti invieremo un link per scegliere una nuova password.",
      forgotSend: "Invia il link", forgotSent: "Se l'email è registrata riceverai a breve un link per reimpostare la password (controlla anche la cartella spam). Il link vale 1 ora.",
      backToLogin: "Torna all'accesso", resetTitle: "Scegli una nuova password", newPassword: "Nuova password", confirmPassword: "Conferma la nuova password",
      resetSave: "Salva la nuova password", resetMismatch: "Le due password non coincidono", resetDone: "Password aggiornata: ora sei nella tua area riservata", resetMissing: "Link non valido: richiedine uno nuovo",
      minChars: "minimo 8 caratteri",
    },
    account: {
      title: "Le mie richieste",
      empty: "Non hai ancora inviato richieste di concept.",
      newRequest: "Nuova richiesta",
      aiPreview: "Stato della richiesta",
      aiGenerating: "Richiesta ricevuta, la stiamo già elaborando. Il progetto definitivo ti arriverà via email.",
      aiError: "Non è stato possibile completare l’elaborazione di questa richiesta. Riprova più tardi o contatta il team FArLight.",
      aiImageAlt: "Moodboard di riferimento",
      submittedOn: "Inviata il",
      viewAccount: "Vai alla tua area personale per seguire lo stato della richiesta",
      createAccount: "Crea un account gratuito per seguire lo stato della tua richiesta",
      downloadPdf: "Scarica il report PDF",
      downloadEditable: "Scarica versione editabile",
      lampSchedule: "Abaco Lampade per rivenditori",
      lampScheduleNote: "Foto, codici e schede tecniche complete sono disponibili sulle pagine ufficiali dei produttori linkate. Prezzi e sconti del capitolato ufficiale sono decisi autonomamente da distributori e rivenditori.",
    },
  },
  en: {
    nav: {
      about: "About Us",
      concept: "Request Concept",
      pricing: "Pricing",
      consulting: "Direct Consulting",
      contact: "Contact",
      method: "Method",
      contactSupport: "Contact & Support",
      cta: "Request Concept",
    },
    hero: {
      overline: "Remote lighting design consulting",
      title: "Light isn't switched on. It's designed.",
      subtitle: "FArLight is the lighting design signature of Alessia Follari and Alessandra Floridia. Tell us about your space, the brands you love and the atmosphere you wish for, and we design the light, with technical rigour and authorial sensitivity.",
      ctaPrimary: "Request your concept",
      ctaSecondary: "See pricing",
      ctaCallNote: "15 minutes, free",
      videoCaption: "Watch the studio presentation",
      videoSoon: "Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia's presentation video is coming soon",
      founders: "Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia — Founders",
    },
    manifesto: {
      overline: "Manifesto — About Us",
      title: "Two professionals in lighting and architecture, one vision of light.",
      p1: "FArLight was born from the friendship between Alessia and Alessandra, university colleagues since their architecture studies. On one side Alessia's lighting design vision and expertise, on the other Alessandra's graphic power and representational sensitivity.",
      p2: "Behind every automated calculation there is human expertise, every report is read, verified and signed by us. Technology speeds up the work, but light is still designed by people.",
      p3: "We work entirely remotely. You send us plans and layouts, we return a concept ready to guide your choices. No site visits, no waiting.",
      signature: "Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia",
      signatureRole: "Founders of FArLight",
    },
    strengths: {
      overline: "The creative and sustainable essence of light",
      title: "The creative and sustainable essence of light.",
      items: [
        { title: "Light as Function and Emotion", desc: "Light guides behaviour, enhances volumes and reduces visual fatigue. In offices, retail and homes we design scenes that work for people." },
        { title: "Sustainability and Smart Energy Saving", desc: "Rigorous LENI (Lighting Energy Numerical Indicator) calculation and targeted luminous flux, for fewer wasted watts, lower environmental impact, unchanged comfort." },
        { title: "Excellent Lighting Design, for Everyone", desc: "Complete, scientific and fast lighting concepts, authorial design quality accessible to every project, with the care of a studio." },
        { title: "Real & Verifiable Results", desc: "Exact match on .LDT files, catalogue codes, brands and price lists, so every choice is verifiable, orderable and site-ready." },
      ],
    },
    tutorial: {
      overline: "Video Tutorial",
      title: "How the platform works, step by step.",
      subtitle: "In a few minutes you'll learn how to upload your plans, complete the request and receive your lighting concept.",
      steps: [
        { title: "Prepare your files", desc: "Gather plans and layouts of the space in PDF, JPG or PNG format." },
        { title: "Fill in the form", desc: "Enter type, surface, height, budget and style, it takes two minutes." },
        { title: "Send and relax", desc: "We check your details and start working on the concept straight away." },
        { title: "Receive the report", desc: "PDF report, moodboard and budget list arrive straight to your inbox." },
      ],
      videoCaption: "Watch the video tutorial",
      videoSoon: "The video tutorial is coming soon",
    },
    form: {
      overline: "Request Preliminary Concept",
      title: "Upload your plans, we handle the rest.",
      leftTitle: "How it works",
      steps: [
        "Fill in the form with the space characteristics",
        "Attach plans and layouts (PDF, JPG, PNG)",
        "Receive the preliminary report signed FArLight",
      ],
      disclaimerShort: "Preliminary lighting concept and feasibility consulting.",
      name: "Full Name / Studio",
      namePlaceholder: "E.g. Studio Bianchi or John Smith",
      email: "Email",
      emailPlaceholder: "name@example.com",
      spaceType: "Space type",
      spaceTypePlaceholder: "Select the type",
      spaceTypes: {
        residenziale: "Residential",
        retail: "Retail / Shop",
        uffici: "Offices",
        outdoor: "Outdoor",
        ristorazione: "Hospitality / Restaurant",
      },
      surface: "Surface (sqm)",
      surfacePlaceholder: "E.g. 85",
      ceiling: "Ceiling height (m)",
      ceilingPlaceholder: "E.g. 2.7",
      budget: "Desired budget range",
      budgetPlaceholder: "Select the range",
      budgets: {
        economico: "Budget",
        medio: "Mid-range",
        alto: "High-end",
      },
      style: "Preferred lighting style",
      stylePlaceholder: "E.g. warm and minimal, scenographic, technical...",
      surfaceApprox: "Approximate / not sure", surfaceApproxShort: "approx.",
      upload: "Attach plans and layouts",
      uploadHint: "PDF, JPG or PNG — max 20MB per file",
      uploadButton: "Choose files",
      uploadEmpty: "No file selected",
      lampSchedule: "Add the Lamp Schedule for retailers",
      lampScheduleHint: "A list with brands, models, photos and reference codes to hand directly to local distributors and retailers, who will prepare the official quote with prices and discounts they decide independently.",
      preferredBrands: "Brands selected from the catalogues",
      notes: "Site notes and constraints",
      notesPlaceholder: "E.g. exposed beams, existing light points, building restrictions...",
      submit: "Send request",
      submitting: "Sending...",
      successTitle: "Request sent",
      successDesc: "Thank you! We've sent you a confirmation email and within a few minutes you'll receive a second email with the link to your PDF report. You can also follow progress in your personal area (log in with the same email).",
      errorDesc: "Something went wrong. Please retry or write to info.farlight.official@gmail.com",
    },
    catalogs: {
      overline: "Resources for designers",
      title: "Catalogues and technical sheets from top brands.",
      subtitle: "Links to the manufacturers' official websites to browse downloadable catalogues and technical sheets to select the lamps for your projects.",
      note: "Catalogues and technical sheets are hosted on the manufacturers' official websites.",
      visit: "Visit website",
      selectHint: "Tap a card to select your preferred brands — the arrow opens the official website",
      addToRequest: "Add to request",
    },
    pricing: {
      overline: "Pricing",
      title: "Clear prices, no surprises.",
      subtitle: "Choose the one-off service or the subscription designed for studios and showrooms.",
      disclaimer: "All reports constitute Preliminary Lighting Concept and Feasibility Consulting to guide initial choices and estimate costs.",
      loading: "Redirecting to secure checkout...",
      error: "Unable to start the payment. Please try again shortly.",
      secure: "Secure payment with Stripe",
    },
    escalation: {
      overline: "Direct Studio Consulting",
      title: "Complex projects? Let's talk in person.",
      subtitle: "Hotels, restorations, public works and advanced retail require a tailored approach. Alessia and Alessandra personally take charge of your project, from site survey to signature.",
      tags: ["Hotels", "Restorations", "Public Works", "Advanced retail"],
      cta: "Request direct handling",
    },
    contact: {
      overline: "Contact & Support",
      title: "Write to us, we reply quickly.",
      name: "Name",
      namePlaceholder: "Your name",
      email: "Email",
      emailPlaceholder: "name@example.com",
      topic: "Request type",
      topicSupport: "Customer support",
      topicDirect: "Direct Studio Consulting",
      message: "Message",
      messagePlaceholder: "Tell us about your project or question...",
      submit: "Send message",
      submitting: "Sending...",
      successTitle: "Message sent",
      successDesc: "Thank you! We will reply as soon as possible.",
      errorDesc: "Sending failed. Write directly to info.farlight.official@gmail.com",
      emailLabel: "Support email",
    },
    footer: {
      tagline: "Remote lighting design, with an author's touch.",
      rights: "All rights reserved.",
    },
    payment: {
      cardLabel: "Credit / debit card", cardDesc: "Secure payment with Stripe (Visa, Mastercard, Amex, Apple/Google Pay).", paypalDesc: "Pay with your PayPal balance or account.", paypalSoon: "Coming soon.",
      successTitle: "Card authorised, no charge yet",
      successDesc: "Thank you for choosing FArLight. Your payment has been confirmed. Your request is already in progress, you will receive a confirmation email and can follow progress in your Reserved Area.",
      pendingTitle: "Verifying your payment...",
      pendingDesc: "We are confirming the transaction with Stripe.",
      failedTitle: "Payment not confirmed",
      failedDesc: "We could not confirm the payment. If you were charged, write to info.farlight.official@gmail.com",
      backHome: "Back to home",
      cancelTitle: "Payment cancelled",
      cancelDesc: "No charge was made. You can resume anytime from the Pricing section.",
      retry: "See pricing",
    },
    auth: {
      login: "Log in",
      register: "Sign up",
      logout: "Log out",
      name: "Name",
      email: "Email",
      password: "Password",
      google: "Continue with Google",
      noAccount: "Don't have an account?",
      haveAccount: "Already have an account?",
      loginTitle: "Log in to FArLight",
      registerTitle: "Create your account",
      subtitle: "Your requests and their status",
      orDivider: "or",
      loginError: "Invalid credentials",
      registerError: "Registration failed (email already in use?)",
      forgot: "Forgot your password?", forgotTitle: "Reset your password", forgotText: "Enter your account email and we will send you a link to choose a new password.",
      forgotSend: "Send the link", forgotSent: "If the email is registered you will shortly receive a link to reset your password (check your spam folder too). The link is valid for 1 hour.",
      backToLogin: "Back to sign in", resetTitle: "Choose a new password", newPassword: "New password", confirmPassword: "Confirm the new password",
      resetSave: "Save the new password", resetMismatch: "The two passwords do not match", resetDone: "Password updated: you are now in your private area", resetMissing: "Invalid link: please request a new one",
      minChars: "minimum 8 characters",
    },
    account: {
      title: "My requests",
      empty: "You haven't submitted any concept requests yet.",
      newRequest: "New request",
      aiPreview: "Request status",
      aiGenerating: "Request received, we are already working on it. The final project will reach you by email.",
      aiError: "We could not complete the processing of this request. Please try again later or contact the FArLight team.",
      aiImageAlt: "Reference moodboard",
      submittedOn: "Submitted on",
      viewAccount: "Go to your personal area to follow your request",
      createAccount: "Create a free account to follow your request",
      downloadPdf: "Download PDF report",
      downloadEditable: "Download editable version",
      lampSchedule: "Lamp Schedule for retailers",
      lampScheduleNote: "Photos, codes and full technical sheets are available on the linked manufacturers' official pages. Prices and discounts of the official quote are decided independently by distributors and retailers.",
    },
  },
  fr: {
    nav: {
      about: "Qui sommes-nous",
      concept: "Demander un Concept",
      pricing: "Tarifs",
      consulting: "Conseil Direct",
      contact: "Contact",
      method: "Méthode",
      contactSupport: "Contact et support",
      cta: "Demander un Concept",
    },
    hero: {
      overline: "Conseil en conception lumineuse à distance",
      title: "La lumière ne s'allume pas. Elle se dessine.",
      subtitle: "FArLight est la signature de lighting design d'Alessia Follari et Alessandra Floridia : racontez-nous votre espace, vos marques et l'atmosphère souhaitée, nous dessinons la lumière.",
      ctaPrimary: "Demandez votre concept",
      ctaSecondary: "Voir les tarifs",
      ctaCallNote: "15 minutes, gratuit",
      videoCaption: "Regardez la présentation du studio",
      videoSoon: "La vidéo de présentation d'Alessia et Alessandra sera bientôt disponible",
      founders: "Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia — Fondatrices",
    },
    manifesto: {
      overline: "Manifeste — Qui sommes-nous",
      title: "Deux professionnelles du lighting et de l'architecture, une seule vision de la lumière.",
      p1: "FArLight est né de l'amitié entre Alessia et Alessandra, collègues d'université pendant leurs études d'architecture. D'un côté la vision et l'expertise en éclairage d'Alessia, de l'autre la puissance graphique et la sensibilité d'Alessandra.",
      p2: "Derrière chaque calcul automatique, il y a une expertise humaine : chaque rapport est lu, vérifié et signé par nous. La technologie accélère le travail, mais la lumière reste conçue par des personnes.",
      p3: "Nous travaillons entièrement à distance : vous nous envoyez plans et layouts, nous vous renvoyons un concept prêt à guider vos choix. Aucune visite de chantier, aucune attente.",
      signature: "Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia",
      signatureRole: "Fondatrices de FArLight",
    },
    strengths: {
      overline: "L'essence créative et durable de la lumière",
      title: "L'essence créative et durable de la lumière.",
      items: [
        { title: "La lumière comme fonction et émotion", desc: "La lumière guide les comportements, valorise les volumes et réduit la fatigue visuelle : bureaux, retail et résidentiel, nous concevons des scènes au service des personnes." },
        { title: "Durabilité et économies d'énergie intelligentes", desc: "Calcul rigoureux du LENI (Lighting Energy Numerical Indicator) et flux lumineux ciblés : moins de watts dispersés, impact réduit, confort inchangé." },
        { title: "Le lighting design d'excellence, pour tous", desc: "Concepts d'éclairage complets, scientifiques et rapides : la qualité d'un studio accessible à chaque projet, avec le soin d'un studio." },
        { title: "Des résultats réels et vérifiables", desc: "Correspondance exacte sur fichiers .LDT, codes catalogue, marques et tarifs : chaque choix est vérifiable, commandable et prêt pour le chantier." },
      ],
    },
    tutorial: {
      overline: "Tutoriel Vidéo",
      title: "Comment fonctionne la plateforme, étape par étape.",
      subtitle: "En quelques minutes, découvrez comment télécharger vos plans, remplir la demande et recevoir votre concept lumineux.",
      steps: [
        { title: "Préparez vos fichiers", desc: "Rassemblez plans et layouts de l'espace en PDF, JPG ou PNG." },
        { title: "Remplissez le formulaire", desc: "Indiquez typologie, surface, hauteur, budget et style : deux minutes suffisent." },
        { title: "Envoyez et détendez-vous", desc: "Le studio vérifie les données et lance immédiatement la création du concept." },
        { title: "Recevez le rapport", desc: "Rapport PDF, moodboard et liste budgétaire arrivent directement par email." },
      ],
      videoCaption: "Regardez le tutoriel vidéo",
      videoSoon: "Le tutoriel vidéo sera bientôt disponible",
    },
    form: {
      overline: "Demander un Concept Préliminaire",
      title: "Téléchargez vos plans, nous nous occupons du reste.",
      leftTitle: "Comment ça marche",
      steps: [
        "Remplissez le formulaire avec les caractéristiques de l'espace",
        "Joignez plans et layouts (PDF, JPG, PNG)",
        "Recevez le rapport préliminaire signé FArLight",
      ],
      disclaimerShort: "Conseil préliminaire de concept et faisabilité lumineuse.",
      name: "Nom et Prénom / Studio",
      namePlaceholder: "Ex. Studio Bianchi ou Marie Dupont",
      email: "Email",
      emailPlaceholder: "nom@exemple.fr",
      spaceType: "Type d'espace",
      spaceTypePlaceholder: "Sélectionnez le type",
      spaceTypes: {
        residenziale: "Résidentiel",
        retail: "Retail / Boutique",
        uffici: "Bureaux",
        outdoor: "Extérieur",
        ristorazione: "Restauration",
      },
      surface: "Surface (m²)",
      surfacePlaceholder: "Ex. 85",
      ceiling: "Hauteur sous plafond (m)",
      ceilingPlaceholder: "Ex. 2.7",
      budget: "Gamme de budget souhaitée",
      budgetPlaceholder: "Sélectionnez la gamme",
      budgets: {
        economico: "Économique",
        medio: "Moyen",
        alto: "Haut de gamme",
      },
      style: "Style d'éclairage préféré",
      stylePlaceholder: "Ex. chaleureux et minimal, scénographique, technique...",
      upload: "Joindre plans et layouts",
      uploadHint: "PDF, JPG ou PNG — max 20Mo par fichier",
      uploadButton: "Choisir des fichiers",
      uploadEmpty: "Aucun fichier sélectionné",
      lampSchedule: "Ajouter l'Abacus des Lampes pour les revendeurs",
      lampScheduleHint: "Liste avec marques, modèles, photos et codes de référence à remettre directement aux distributeurs et revendeurs locaux, qui prépareront le devis officiel avec prix et remises décidés en toute autonomie.",
      preferredBrands: "Marques sélectionnées dans les catalogues",
      notes: "Notes et contraintes de chantier",
      notesPlaceholder: "Ex. poutres apparentes, points lumineux existants, contraintes de copropriété...",
      submit: "Envoyer la demande",
      submitting: "Envoi en cours...",
      successTitle: "Demande envoyée",
      successDesc: "Merci ! Un email de confirmation vous a été envoyé : dans quelques minutes vous recevrez un second email avec le lien vers votre rapport PDF. Suivez aussi l'avancement dans votre espace personnel (même email).",
      errorDesc: "Une erreur est survenue. Réessayez ou écrivez à info.farlight.official@gmail.com",
    },
    catalogs: {
      overline: "Ressources pour concepteurs",
      title: "Catalogues et fiches techniques des meilleures marques.",
      subtitle: "Les liens vers les sites officiels des fabricants : consultez les catalogues téléchargeables et les fiches techniques pour sélectionner les lampes de vos projets.",
      note: "Les catalogues et fiches techniques sont hébergés sur les sites officiels des fabricants.",
      visit: "Visiter le site",
      selectHint: "Touchez une carte pour sélectionner vos marques préférées — la flèche ouvre le site officiel",
      addToRequest: "Ajouter à la demande",
    },
    pricing: {
      overline: "Tarifs",
      title: "Des prix clairs, sans surprises.",
      subtitle: "Choisissez la prestation unique ou l'abonnement pensé pour les studios et showrooms.",
      disclaimer: "Tous les rapports constituent un Conseil Préliminaire de Concept et Faisabilité Lumineuse pour guider les choix initiaux et estimer les coûts.",
      loading: "Redirection vers le paiement sécurisé...",
      error: "Impossible de démarrer le paiement. Réessayez dans un instant.",
      secure: "Paiement sécurisé avec Stripe",
    },
    escalation: {
      overline: "Conseil Direct du Studio",
      title: "Projets complexes ? Parlons-en en personne.",
      subtitle: "Hôtels, restaurations, ouvrages publics et retail avancé exigent une approche sur mesure : Alessia et Alessandra prennent personnellement en charge votre projet, de la visite à la signature.",
      tags: ["Hôtels", "Restaurations", "Ouvrages Publics", "Retail avancé"],
      cta: "Demander la prise en charge",
    },
    contact: {
      overline: "Contact & Support",
      title: "Écrivez-nous, nous répondons vite.",
      name: "Nom",
      namePlaceholder: "Votre nom",
      email: "Email",
      emailPlaceholder: "nom@exemple.fr",
      topic: "Type de demande",
      topicSupport: "Support client",
      topicDirect: "Conseil Direct du Studio",
      message: "Message",
      messagePlaceholder: "Parlez-nous de votre projet ou de votre question...",
      submit: "Envoyer le message",
      submitting: "Envoi en cours...",
      successTitle: "Message envoyé",
      successDesc: "Merci ! Nous vous répondrons au plus vite.",
      errorDesc: "Échec de l'envoi. Écrivez directement à info.farlight.official@gmail.com",
      emailLabel: "Email support",
    },
    footer: {
      tagline: "Conception lumineuse à distance, d'auteur.",
      rights: "Tous droits réservés.",
    },
    payment: {
      successTitle: "Paiement confirmé",
      successDesc: "Merci d'avoir choisi FArLight. Vous recevrez un email de confirmation et pourrez nous envoyer votre projet.",
      pendingTitle: "Vérification du paiement...",
      pendingDesc: "Nous confirmons la transaction avec Stripe.",
      failedTitle: "Paiement non confirmé",
      failedDesc: "Impossible de confirmer le paiement. En cas de débit, écrivez à info.farlight.official@gmail.com",
      backHome: "Retour à l'accueil",
      cancelTitle: "Paiement annulé",
      cancelDesc: "Aucun débit n'a été effectué. Vous pouvez reprendre quand vous voulez depuis la section Tarifs.",
      retry: "Voir les tarifs",
    },
    auth: {
      login: "Se connecter",
      register: "S'inscrire",
      logout: "Se déconnecter",
      name: "Nom",
      email: "Email",
      password: "Mot de passe",
      google: "Continuer avec Google",
      noAccount: "Pas encore de compte ?",
      haveAccount: "Vous avez déjà un compte ?",
      loginTitle: "Connexion à FArLight",
      registerTitle: "Créez votre compte",
      subtitle: "Gérez vos demandes et leur avancement",
      orDivider: "ou",
      loginError: "Identifiants invalides",
      registerError: "Inscription impossible (email déjà utilisé ?)",
      forgot: "Mot de passe oublié ?", forgotTitle: "Réinitialiser le mot de passe", forgotText: "Saisissez l'email de votre compte : nous vous enverrons un lien pour choisir un nouveau mot de passe.",
      forgotSend: "Envoyer le lien", forgotSent: "Si l'email est enregistré, vous recevrez bientôt un lien de réinitialisation (vérifiez aussi les spams). Le lien est valable 1 heure.",
      backToLogin: "Retour à la connexion", resetTitle: "Choisissez un nouveau mot de passe", newPassword: "Nouveau mot de passe", confirmPassword: "Confirmez le nouveau mot de passe",
      resetSave: "Enregistrer le mot de passe", resetMismatch: "Les deux mots de passe ne correspondent pas", resetDone: "Mot de passe mis à jour : vous êtes dans votre espace réservé", resetMissing: "Lien non valide : demandez-en un nouveau",
      minChars: "8 caractères minimum",
    },
    account: {
      title: "Mes demandes",
      empty: "Vous n'avez pas encore envoyé de demande de concept.",
      newRequest: "Nouvelle demande",
      aiPreview: "Statut de la demande",
      aiGenerating: "Demande reçue — en cours d'élaboration par l'équipe FArLight.",
      aiError: "Le traitement de cette demande n’a pas pu être finalisé. Réessayez plus tard ou contactez l’équipe FArLight.",
      aiImageAlt: "Moodboard de référence",
      submittedOn: "Envoyée le",
      viewAccount: "Accédez à votre espace personnel pour suivre votre demande",
      createAccount: "Créez un compte gratuit pour suivre votre demande",
      downloadPdf: "Télécharger le rapport PDF",
      downloadEditable: "Télécharger la version modifiable",
      lampSchedule: "Abacus des Lampes pour revendeurs",
      lampScheduleNote: "Photos, codes et fiches techniques complètes sont disponibles sur les pages officielles des fabricants liées. Les prix et remises du devis officiel sont décidés en toute autonomie par les distributeurs et revendeurs.",
    },
  },
  de: {
    nav: {
      about: "Über uns",
      concept: "Concept anfragen",
      pricing: "Preise",
      consulting: "Direktberatung",
      contact: "Kontakt",
      method: "Methode",
      contactSupport: "Kontakt & Support",
      cta: "Concept anfragen",
    },
    hero: {
      overline: "Lichtplanung-Beratung aus der Ferne",
      title: "Licht wird nicht eingeschaltet. Es wird entworfen.",
      subtitle: "FArLight ist die Lighting-Design-Handschrift von Alessia Follari und Alessandra Floridia: erzählen Sie uns von Ihrem Raum, Ihren Marken und der gewünschten Atmosphäre – wir gestalten das Licht.",
      ctaPrimary: "Fordern Sie Ihr Concept an",
      ctaSecondary: "Preise ansehen",
      ctaCallNote: "15 Minuten, kostenlos",
      videoCaption: "Studiovorstellung ansehen",
      videoSoon: "Das Vorstellungsvideo von Alessia und Alessandra erscheint in Kürze",
      founders: "Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia — Gründerinnen",
    },
    manifesto: {
      overline: "Manifest — Über uns",
      title: "Zwei Fachfrauen für Lighting und Architektur, eine Vision des Lichts.",
      p1: "FArLight entstand aus der Freundschaft zwischen Alessia und Alessandra, Studienkolleginnen seit dem Architekturstudium. Auf der einen Seite Alessias Vision und lichttechnische Kompetenz, auf der anderen Alessandras grafische Kraft und darstellerische Sensibilität.",
      p2: "Hinter jeder automatischen Berechnung steckt menschliche Kompetenz: Jeder Bericht wird von uns gelesen, geprüft und signiert. Technologie beschleunigt die Arbeit, aber Licht wird immer noch von Menschen gestaltet.",
      p3: "Wir arbeiten vollständig remote: Sie senden uns Pläne und Layouts, wir liefern ein Concept, das Ihre Entscheidungen leitet. Kein Ortstermin, keine Wartezeit.",
      signature: "Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia",
      signatureRole: "Gründerinnen von FArLight",
    },
    strengths: {
      overline: "Die kreative und nachhaltige Essenz des Lichts",
      title: "Die kreative und nachhaltige Essenz des Lichts.",
      items: [
        { title: "Licht als Funktion und Emotion", desc: "Licht lenkt Verhalten, betont Volumen und reduziert visuelle Ermüdung: In Büro, Retail und Wohnen planen wir Szenen, die für Menschen arbeiten." },
        { title: "Nachhaltigkeit und intelligentes Energiesparen", desc: "Rigorose LENI-Berechnung (Lighting Energy Numerical Indicator) und gezielte Lichtströme: weniger verschwendete Watt, geringere Umweltbelastung, gleicher Komfort." },
        { title: "Exzellentes Lighting Design, für alle", desc: "Vollständige, wissenschaftliche und schnelle Lichtkonzepte: Studioqualität für jedes Projekt, in unter 60 Sekunden." },
        { title: "Echte & überprüfbare Ergebnisse", desc: "Exakte Übereinstimmung mit .LDT-Dateien, Katalogcodes, Marken und Preislisten: Jede Wahl ist prüfbar, bestellbar und baustellenreif." },
      ],
    },
    tutorial: {
      overline: "Video-Tutorial",
      title: "So funktioniert die Plattform, Schritt für Schritt.",
      subtitle: "In wenigen Minuten lernen Sie, wie Sie Pläne hochladen, die Anfrage ausfüllen und Ihr Lichtconcept erhalten.",
      steps: [
        { title: "Dateien vorbereiten", desc: "Sammeln Sie Pläne und Layouts des Raums als PDF, JPG oder PNG." },
        { title: "Formular ausfüllen", desc: "Typologie, Fläche, Höhe, Budget und Stil angeben: zwei Minuten genügen." },
        { title: "Absenden und entspannen", desc: "Das Studio prüft die Daten und startet sofort mit der Bearbeitung des Concepts." },
        { title: "Bericht erhalten", desc: "PDF-Bericht, Moodboard und Budgetliste kommen direkt per E-Mail." },
      ],
      videoCaption: "Video-Tutorial ansehen",
      videoSoon: "Das Video-Tutorial erscheint in Kürze",
    },
    form: {
      overline: "Vorläufiges Concept anfragen",
      title: "Laden Sie Ihre Pläne hoch, wir kümmern uns um den Rest.",
      leftTitle: "So funktioniert es",
      steps: [
        "Füllen Sie das Formular mit den Merkmalen des Raums aus",
        "Fügen Sie Pläne und Layouts bei (PDF, JPG, PNG)",
        "Erhalten Sie den vorläufigen Bericht, signiert von FArLight",
      ],
      disclaimerShort: "Vorläufige Beratung zu Lichtconcept und Machbarkeit.",
      name: "Vor- und Nachname / Studio",
      namePlaceholder: "z.B. Studio Bianchi oder Max Mustermann",
      email: "E-Mail",
      emailPlaceholder: "name@beispiel.de",
      spaceType: "Art des Raums",
      spaceTypePlaceholder: "Typ auswählen",
      spaceTypes: {
        residenziale: "Wohnen",
        retail: "Retail / Geschäft",
        uffici: "Büros",
        outdoor: "Außenbereich",
        ristorazione: "Gastronomie",
      },
      surface: "Fläche (m²)",
      surfacePlaceholder: "z.B. 85",
      ceiling: "Deckenhöhe (m)",
      ceilingPlaceholder: "z.B. 2.7",
      budget: "Gewünschter Budgetrahmen",
      budgetPlaceholder: "Rahmen auswählen",
      budgets: {
        economico: "Günstig",
        medio: "Mittel",
        alto: "Gehoben",
      },
      style: "Bevorzugter Beleuchtungsstil",
      stylePlaceholder: "z.B. warm und minimal, szenografisch, technisch...",
      upload: "Pläne und Layouts anhängen",
      uploadHint: "PDF, JPG oder PNG — max. 20MB pro Datei",
      uploadButton: "Dateien wählen",
      uploadEmpty: "Keine Datei ausgewählt",
      lampSchedule: "Leuchtenverzeichnis für Händler hinzufügen",
      lampScheduleHint: "Liste mit Marken, Modellen, Fotos und Referenzcodes zur direkten Weitergabe an lokale Distributoren und Händler, die das offizielle Angebot mit Preisen und Rabatten eigenständig erstellen.",
      preferredBrands: "Aus den Katalogen ausgewählte Marken",
      notes: "Baustellennotizen und Einschränkungen",
      notesPlaceholder: "z.B. Sichtbalken, vorhandene Lichtpunkte, Eigentümer-Vorgaben...",
      submit: "Anfrage senden",
      submitting: "Wird gesendet...",
      successTitle: "Anfrage gesendet",
      successDesc: "Danke! Wir haben Ihnen eine Bestätigungs-E-Mail gesendet: In wenigen Minuten erhalten Sie eine zweite E-Mail mit dem Link zu Ihrem PDF-Bericht. Den Fortschritt sehen Sie auch in Ihrem persönlichen Bereich (gleiche E-Mail).",
      errorDesc: "Etwas ist schiefgelaufen. Bitte erneut versuchen oder an info.farlight.official@gmail.com schreiben",
    },
    catalogs: {
      overline: "Ressourcen für Planer",
      title: "Kataloge und Datenblätter der besten Marken.",
      subtitle: "Links zu den offiziellen Hersteller-Websites: Durchsuchen Sie herunterladbare Kataloge und Datenblätter, um die Leuchten für Ihre Projekte auszuwählen.",
      note: "Kataloge und Datenblätter werden auf den offiziellen Websites der jeweiligen Hersteller gehostet.",
      visit: "Website besuchen",
      selectHint: "Tippen Sie auf eine Karte, um Ihre bevorzugten Marken auszuwählen — der Pfeil öffnet die offizielle Website",
      addToRequest: "Zur Anfrage hinzufügen",
    },
    pricing: {
      overline: "Preise",
      title: "Klare Preise, keine Überraschungen.",
      subtitle: "Wählen Sie die Einzelleistung oder das Abonnement für Studios und Showrooms.",
      disclaimer: "Alle Berichte stellen eine vorläufige Beratung zu Lichtconcept und Machbarkeit dar, um erste Entscheidungen zu leiten und Kosten abzuschätzen.",
      loading: "Weiterleitung zur sicheren Zahlung...",
      error: "Zahlung konnte nicht gestartet werden. Bitte gleich erneut versuchen.",
      secure: "Sichere Zahlung mit Stripe",
    },
    escalation: {
      overline: "Direkte Studio-Beratung",
      title: "Komplexe Projekte? Sprechen wir persönlich.",
      subtitle: "Hotels, Restaurierungen, öffentliche Bauten und anspruchsvoller Retail erfordern einen maßgeschneiderten Ansatz: Alessia und Alessandra übernehmen Ihr Projekt persönlich, vom Ortstermin bis zur Unterschrift.",
      tags: ["Hotels", "Restaurierungen", "Öffentliche Bauten", "Anspruchsvoller Retail"],
      cta: "Übernahme anfragen",
    },
    contact: {
      overline: "Kontakt & Support",
      title: "Schreiben Sie uns, wir antworten schnell.",
      name: "Name",
      namePlaceholder: "Ihr Name",
      email: "E-Mail",
      emailPlaceholder: "name@beispiel.de",
      topic: "Art der Anfrage",
      topicSupport: "Kundensupport",
      topicDirect: "Direkte Studio-Beratung",
      message: "Nachricht",
      messagePlaceholder: "Erzählen Sie uns von Ihrem Projekt oder Ihrer Frage...",
      submit: "Nachricht senden",
      submitting: "Wird gesendet...",
      successTitle: "Nachricht gesendet",
      successDesc: "Danke! Wir antworten so schnell wie möglich.",
      errorDesc: "Senden fehlgeschlagen. Schreiben Sie direkt an info.farlight.official@gmail.com",
      emailLabel: "Support-E-Mail",
    },
    footer: {
      tagline: "Lichtplanung aus der Ferne, mit Autorenanspruch.",
      rights: "Alle Rechte vorbehalten.",
    },
    payment: {
      successTitle: "Zahlung bestätigt",
      successDesc: "Danke, dass Sie FArLight gewählt haben. Sie erhalten eine Bestätigungs-E-Mail und können uns dann Ihr Projekt senden.",
      pendingTitle: "Zahlung wird geprüft...",
      pendingDesc: "Wir bestätigen die Transaktion mit Stripe.",
      failedTitle: "Zahlung nicht bestätigt",
      failedDesc: "Die Zahlung konnte nicht bestätigt werden. Bei erfolgter Belastung schreiben Sie an info.farlight.official@gmail.com",
      backHome: "Zur Startseite",
      cancelTitle: "Zahlung abgebrochen",
      cancelDesc: "Es erfolgte keine Belastung. Sie können jederzeit im Bereich Preise fortfahren.",
      retry: "Preise ansehen",
    },
    auth: {
      login: "Anmelden",
      register: "Registrieren",
      logout: "Abmelden",
      name: "Name",
      email: "E-Mail",
      password: "Passwort",
      google: "Mit Google fortfahren",
      noAccount: "Noch kein Konto?",
      haveAccount: "Bereits ein Konto?",
      loginTitle: "Bei FArLight anmelden",
      registerTitle: "Konto erstellen",
      subtitle: "Verwalten Sie Ihre Anfragen und deren Status",
      orDivider: "oder",
      loginError: "Ungültige Zugangsdaten",
      registerError: "Registrierung fehlgeschlagen (E-Mail bereits vergeben?)",
      forgot: "Passwort vergessen?", forgotTitle: "Passwort zurücksetzen", forgotText: "Geben Sie die E-Mail Ihres Kontos ein: Wir senden Ihnen einen Link, um ein neues Passwort zu wählen.",
      forgotSend: "Link senden", forgotSent: "Wenn die E-Mail registriert ist, erhalten Sie in Kürze einen Link zum Zurücksetzen (prüfen Sie auch den Spam-Ordner). Der Link ist 1 Stunde gültig.",
      backToLogin: "Zurück zur Anmeldung", resetTitle: "Neues Passwort wählen", newPassword: "Neues Passwort", confirmPassword: "Neues Passwort bestätigen",
      resetSave: "Neues Passwort speichern", resetMismatch: "Die beiden Passwörter stimmen nicht überein", resetDone: "Passwort aktualisiert: Sie sind jetzt in Ihrem Bereich", resetMissing: "Ungültiger Link: bitte fordern Sie einen neuen an",
      minChars: "mindestens 8 Zeichen",
    },
    account: {
      title: "Meine Anfragen",
      empty: "Sie haben noch keine Concept-Anfragen gesendet.",
      newRequest: "Neue Anfrage",
      aiPreview: "Status der Anfrage",
      aiGenerating: "Anfrage erhalten — in Bearbeitung durch das FArLight-Team.",
      aiError: "Die Bearbeitung dieser Anfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es später erneut oder kontaktieren Sie das FArLight-Team.",
      aiImageAlt: "Referenz-Moodboard",
      submittedOn: "Gesendet am",
      viewAccount: "Verfolgen Sie Ihre Anfrage in Ihrem persönlichen Bereich",
      createAccount: "Erstellen Sie ein kostenloses Konto, um Ihre Anfrage zu verfolgen",
      downloadPdf: "PDF-Bericht herunterladen",
      downloadEditable: "Editierbare Version herunterladen",
      lampSchedule: "Leuchtenverzeichnis für Händler",
      lampScheduleNote: "Fotos, Codes und vollständige Datenblätter finden Sie auf den verlinkten offiziellen Herstellerseiten. Preise und Rabatte des offiziellen Angebots werden eigenständig von Distributoren und Händlern festgelegt.",
    },
  },
  es: {
    nav: {
      about: "Quiénes somos",
      concept: "Solicitar Concept",
      pricing: "Precios",
      consulting: "Consultoría Directa",
      contact: "Contacto",
      method: "Método",
      contactSupport: "Contacto y soporte",
      cta: "Solicitar Concept",
    },
    hero: {
      overline: "Consultoría de diseño lumínico a distancia",
      title: "La luz no se encende. Se diseña.",
      subtitle: "FArLight es la firma de lighting design de Alessia Follari y Alessandra Floridia: cuéntanos tu espacio, tus marcas y la atmósfera deseada, nosotras diseñamos la luz.",
      ctaPrimary: "Solicita tu concept",
      ctaSecondary: "Ver precios",
      ctaCallNote: "15 minutos, gratuita",
      videoCaption: "Mira la presentación del estudio",
      videoSoon: "El vídeo de presentación de Alessia y Alessandra estará disponible pronto",
      founders: "Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia — Fundadoras",
    },
    manifesto: {
      overline: "Manifiesto — Quiénes somos",
      title: "Dos profesionales del lighting y la arquitectura, una sola visión de la luz.",
      p1: "FArLight nace de la amistad entre Alessia y Alessandra, compañeras de universidad desde los estudios de arquitectura. Por un lado la visión y la competencia lumínica de Alessia, por el otro la potencia gráfica y la sensibilidad de Alessandra.",
      p2: "Detrás de cada cálculo automático hay experiencia humana: cada informe es leído, verificado y firmado por nosotras. La tecnología acelera el trabajo, pero la luz la siguen diseñando las personas.",
      p3: "Trabajamos totalmente a distancia: nos envías planos y layouts, te devolvemos un concept listo para guiar tus decisiones. Sin visitas de obra, sin esperas.",
      signature: "Arch. e Lighting Designer Alessia Follari & Architetto Alessandra Floridia",
      signatureRole: "Fundadoras de FArLight",
    },
    strengths: {
      overline: "La esencia creativa y sostenible de la luz",
      title: "La esencia creativa y sostenible de la luz.",
      items: [
        { title: "La luz como función y emoción", desc: "La luz guía los comportamientos, valoriza los volúmenes y reduce la fatiga visual: en oficinas, retail y vivienda diseñamos escenas que trabajan para las personas." },
        { title: "Sostenibilidad y ahorro energético inteligente", desc: "Cálculo riguroso del LENI (Lighting Energy Numerical Indicator) y flujos luminosos dirigidos: menos vatios dispersos, menor impacto ambiental, confort intacto." },
        { title: "Lighting design de excelencia, para todos", desc: "Concepts lumínicos completos, científicos y rápidos: la calidad de un estudio accesible a cada proyecto, con el cuidado de un estudio." },
        { title: "Resultados reales y verificables", desc: "Correspondencia exacta en archivos .LDT, códigos de catálogo, marcas y tarifas: cada elección es verificable, pedible y lista para obra." },
      ],
    },
    tutorial: {
      overline: "Vídeo Tutorial",
      title: "Cómo funciona la plataforma, paso a paso.",
      subtitle: "En pocos minutos descubrirás cómo subir tus planos, completar la solicitud y recibir tu concept lumínico.",
      steps: [
        { title: "Prepara tus archivos", desc: "Reúne planos y layouts del espacio en PDF, JPG o PNG." },
        { title: "Completa el formulario", desc: "Indica tipología, superficie, altura, presupuesto y estilo: solo dos minutos." },
        { title: "Envía y relájate", desc: "El estudio verifica los datos e inicia de inmediato la elaboración del concept." },
        { title: "Recibe el informe", desc: "Informe PDF, moodboard y lista de presupuesto llegan directamente por email." },
      ],
      videoCaption: "Mira el vídeo tutorial",
      videoSoon: "El vídeo tutorial estará disponible pronto",
    },
    form: {
      overline: "Solicitar Concept Preliminar",
      title: "Sube tus planos, nosotras nos ocupamos del resto.",
      leftTitle: "Cómo funciona",
      steps: [
        "Completa el formulario con las características del espacio",
        "Adjunta planos y layouts (PDF, JPG, PNG)",
        "Recibe el informe preliminar firmado FArLight",
      ],
      disclaimerShort: "Consultoría preliminar de concept y viabilidad lumínica.",
      name: "Nombre y Apellido / Estudio",
      namePlaceholder: "Ej. Studio Bianchi o María García",
      email: "Email",
      emailPlaceholder: "nombre@ejemplo.es",
      spaceType: "Tipo de espacio",
      spaceTypePlaceholder: "Selecciona el tipo",
      spaceTypes: {
        residenziale: "Residencial",
        retail: "Retail / Tienda",
        uffici: "Oficinas",
        outdoor: "Exterior",
        ristorazione: "Restauración",
      },
      surface: "Superficie (m²)",
      surfacePlaceholder: "Ej. 85",
      ceiling: "Altura de techo (m)",
      ceilingPlaceholder: "Ej. 2.7",
      budget: "Rango de presupuesto deseado",
      budgetPlaceholder: "Selecciona el rango",
      budgets: {
        economico: "Económico",
        medio: "Medio",
        alto: "Alto",
      },
      style: "Estilo de iluminación preferido",
      stylePlaceholder: "Ej. cálido y minimal, escenográfico, técnico...",
      upload: "Adjuntar planos y layouts",
      uploadHint: "PDF, JPG o PNG — máx. 20MB por archivo",
      uploadButton: "Elegir archivos",
      uploadEmpty: "Ningún archivo seleccionado",
      lampSchedule: "Añadir el Abaco de Lámparas para distribuidores",
      lampScheduleHint: "Lista con marcas, modelos, fotos y códigos de referencia para entregar directamente a distribuidores y minoristas locales, que prepararán el presupuesto oficial con precios y descuentos decididos de forma independiente.",
      preferredBrands: "Marcas seleccionadas de los catálogos",
      notes: "Notas y limitaciones de obra",
      notesPlaceholder: "Ej. vigas vistas, puntos de luz existentes, normas de comunidad...",
      submit: "Enviar solicitud",
      submitting: "Enviando...",
      successTitle: "Solicitud enviada",
      successDesc: "¡Gracias! Te hemos enviado un email de confirmación: en pocos minutos recibirás un segundo email con el enlace a tu informe PDF. También puedes seguir el avance en tu área personal (misma email).",
      errorDesc: "Algo salió mal. Inténtalo de nuevo o escribe a info.farlight.official@gmail.com",
    },
    catalogs: {
      overline: "Recursos para proyectistas",
      title: "Catálogos y fichas técnicas de las mejores marcas.",
      subtitle: "Enlaces a los sitios oficiales de los fabricantes: consulta catálogos descargables y fichas técnicas para seleccionar las lámparas de tus proyectos.",
      note: "Los catálogos y las fichas técnicas están alojados en los sitios oficiales de los respectivos fabricantes.",
      visit: "Visitar el sitio",
      selectHint: "Toca una tarjeta para seleccionar tus marcas preferidas — la flecha abre el sitio oficial",
      addToRequest: "Añadir a la solicitud",
    },
    pricing: {
      overline: "Precios",
      title: "Precios claros, sin sorpresas.",
      subtitle: "Elige la prestación única o la suscripción pensada para estudios y showrooms.",
      disclaimer: "Todos los informes constituyen una Consultoría Preliminar de Concept y Viabilidad Lumínica para guiar las decisiones iniciales y estimar los costes.",
      loading: "Redirigiendo al pago seguro...",
      error: "No se pudo iniciar el pago. Inténtalo de nuevo en un momento.",
      secure: "Pago seguro con Stripe",
    },
    escalation: {
      overline: "Consultoría Directa del Estudio",
      title: "¿Proyectos complejos? Hablemos en persona.",
      subtitle: "Hoteles, restauraciones, obras públicas y retail avanzado requieren un enfoque a medida: Alessia y Alessandra se hacen cargo personalmente de tu proyecto, de la visita a la firma.",
      tags: ["Hoteles", "Restauraciones", "Obras Públicas", "Retail avanzado"],
      cta: "Solicitar la toma a cargo",
    },
    contact: {
      overline: "Contacto & Soporte",
      title: "Escríbenos, respondemos rápido.",
      name: "Nombre",
      namePlaceholder: "Tu nombre",
      email: "Email",
      emailPlaceholder: "nombre@ejemplo.es",
      topic: "Tipo de solicitud",
      topicSupport: "Soporte al cliente",
      topicDirect: "Consultoría Directa del Estudio",
      message: "Mensaje",
      messagePlaceholder: "Cuéntanos tu proyecto o tu pregunta...",
      submit: "Enviar mensaje",
      submitting: "Enviando...",
      successTitle: "Mensaje enviado",
      successDesc: "¡Gracias! Te responderemos lo antes posible.",
      errorDesc: "Envío fallido. Escribe directamente a info.farlight.official@gmail.com",
      emailLabel: "Email de soporte",
    },
    footer: {
      tagline: "Diseño lumínico a distancia, de autor.",
      rights: "Todos los derechos reservados.",
    },
    payment: {
      successTitle: "Pago confirmado",
      successDesc: "Gracias por elegir FArLight. Recibirás un email de confirmación y podrás enviarnos tu proyecto.",
      pendingTitle: "Verificando el pago...",
      pendingDesc: "Estamos confirmando la transacción con Stripe.",
      failedTitle: "Pago no confirmado",
      failedDesc: "No pudimos confirmar el pago. Si se realizó el cargo, escribe a info.farlight.official@gmail.com",
      backHome: "Volver al inicio",
      cancelTitle: "Pago cancelado",
      cancelDesc: "No se realizó ningún cargo. Puedes retomar cuando quieras desde la sección Precios.",
      retry: "Ver precios",
    },
    auth: {
      login: "Iniciar sesión",
      register: "Registrarse",
      logout: "Cerrar sesión",
      name: "Nombre",
      email: "Email",
      password: "Contraseña",
      google: "Continuar con Google",
      noAccount: "¿No tienes cuenta?",
      haveAccount: "¿Ya tienes cuenta?",
      loginTitle: "Accede a FArLight",
      registerTitle: "Crea tu cuenta",
      subtitle: "Gestiona tus solicitudes y su estado",
      orDivider: "o",
      loginError: "Credenciales no válidas",
      registerError: "Registro fallido (¿email ya en uso?)",
      forgot: "¿Has olvidado la contraseña?", forgotTitle: "Restablecer la contraseña", forgotText: "Introduce el email de tu cuenta: te enviaremos un enlace para elegir una nueva contraseña.",
      forgotSend: "Enviar el enlace", forgotSent: "Si el email está registrado recibirás en breve un enlace para restablecer la contraseña (revisa también el spam). El enlace vale 1 hora.",
      backToLogin: "Volver al acceso", resetTitle: "Elige una nueva contraseña", newPassword: "Nueva contraseña", confirmPassword: "Confirma la nueva contraseña",
      resetSave: "Guardar la nueva contraseña", resetMismatch: "Las dos contraseñas no coinciden", resetDone: "Contraseña actualizada: ya estás en tu área reservada", resetMissing: "Enlace no válido: solicita uno nuevo",
      minChars: "mínimo 8 caracteres",
    },
    account: {
      title: "Mis solicitudes",
      empty: "Aún no has enviado solicitudes de concept.",
      newRequest: "Nueva solicitud",
      aiPreview: "Estado de la solicitud",
      aiGenerating: "Solicitud recibida — en elaboración por el equipo FArLight.",
      aiError: "No se ha podido completar el procesamiento de esta solicitud. Inténtelo de nuevo más tarde o contacte con el equipo FArLight.",
      aiImageAlt: "Moodboard de referencia",
      submittedOn: "Enviada el",
      viewAccount: "Ve a tu área personal para seguir tu solicitud",
      createAccount: "Crea una cuenta gratuita para seguir tu solicitud",
      downloadPdf: "Descargar informe PDF",
      downloadEditable: "Descargar versión editable",
      lampSchedule: "Abaco de Lámparas para distribuidores",
      lampScheduleNote: "Fotos, códigos y fichas técnicas completas están disponibles en las páginas oficiales de los fabricantes enlazadas. Los precios y descuentos del presupuesto oficial los deciden de forma independiente distribuidores y minoristas.",
    },
  },
};

function mergeDeep(base, over) {
  const out = { ...base };
  for (const k of Object.keys(over || {})) {
    const b = base?.[k], o = over[k];
    out[k] = o && typeof o === "object" && !Array.isArray(o) && b && typeof b === "object" && !Array.isArray(b) ? mergeDeep(b, o) : o;
  }
  return out;
}

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("farlight_lang") || "it");

  useEffect(() => {
    localStorage.setItem("farlight_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  // Italian extra texts are the lowest layer, so a key missing in another language falls back instead of crashing the page
  const t = mergeDeep(mergeDeep(mergeDeep(extra.it || {}, translations.en), extra.en), mergeDeep(translations[lang], extra[lang] || {}));

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
